/**
 * Pushes a custom event into the GTM dataLayer.
 * Used to fire Google Ads conversion tags configured inside container GTM-M7PSF467.
 *
 * Events:
 *  - whatsapp_click       → any WhatsApp link/button click
 *  - email_form_submit    → contact form "Send Email" submission
 *  - whatsapp_form_submit → contact form "Send WhatsApp" submission
 */
export function track(event: string, params?: Record<string, unknown>) {
  if (typeof window === "undefined") return;
  const w = window as unknown as { dataLayer?: Array<Record<string, unknown>> };
  w.dataLayer = w.dataLayer || [];
  w.dataLayer.push({ event, ...params });
}